import isElectron from "is-electron";
import { store } from "./store";
import { VIDEO_CONSTRAINS } from "./Constants";
import { roomClient } from "./index";
import Logger from "./Logger";
import * as axios from "axios";
import FileDownload from "js-file-download";
import { makePeerConsumerSelector } from "./components/Selectors";
import * as FileServerClient from "../src/components/Clients/FileServerClient";

const logger = new Logger("DESKTOP");

const crypto = require("crypto");

export class ElectronDesktopApp {
  _onSendWindowId = null;
  _onGetPeers = null;
  _onGetParticipantPeers = null;
  _onShowWebcam = null;
  _onQueryStatus = null;
  _onToggleScreenPin = null;
  _onDisableWebcamShare = null;
  
  constructor() {
    this.subscribeToElectronEvents();
  }

  onToggleScreenPin() {
    logger.info("REGISTER", "onToggleScreenPin");
    this._onToggleScreenPin = window.electronApi.onToggleScreenPin(
      this.handleOnToggleScreen
    );
  }

  onSendWindowId() {
    logger.info("REGISTER", "onSendWindowId");
    this._onSendWindowId = window.electronApi.onSendWindowId(
      this.handleOnSendWindow
    );
  }

  onGetPeers() {
    logger.info("REGISTER", "onGetPeers");
    if (isElectron()) {
      this._onGetPeers = window.electronApi?.onGetPeers(this.handleOnGetPeers);
    }
  }

  onGetParticipantPeers() {
    logger.info("REGISTER", "onGetParticipantPeers");
    this._onGetParticipantPeers = window.electronApi.onGetParticipantPeers(
      this.handleSendParticipantPeers
    );
  }

  onShowWebcam() {
    logger.info("REGISTER", "onShowWebcam");
    if (isElectron()) {
      this._onShowWebcam = window.electronApi.onShowWebcam(
        this.handleListenWebCam
      );
    }
  }

  onDisableWebcamShare() {
    logger.info("REGISTER", "onDisableWebcamShare");
    this._onDisableWebcamShare = window.electronApi.onDisableWebcamShare(
      (event, args) => {
        roomClient.disableWebcam();
      }
    );
  }

  onEnableMicShare() {
    logger.info("REGISTER", "onEnableMicShare");
    this._onEnableMicShare = window.electronApi.onEnableMicShare(
      (event, args) => {
        console.log("onEnableMicShare()");
        roomClient.enableMic();
      }
    );
  }

  onDisableScreenShare() {
    logger.info("REGISTER", "onDisableScreenShare");

    this._onDisableScreenShare = window.electronApi.onDisableScreenShare(
      (event, args) => {
        roomClient.disableScreenSharing();
      }
    );
  }

  onDisableMicShare() {
    logger.info("REGISTER", "onDisableMicShare");

    this._onDisableMicShare = window.electronApi.onDisableMicShare(
      (event, args) => {
        console.log("onDisableMicShare()");
        roomClient.disableMic();
      }
    );
  }

  onEnableWebcamShare() {
    logger.info("REGISTER", "onEnableWebcamShare");

    this._onEnableWebcamShare = window.electronApi.onEnableWebcamShare(
      (event, args) => {
        roomClient.enableWebcam();
      }
    );
  }

  onGetStatus() {
    logger.info("REGISTER", "onGetStatus");
    if (isElectron()) {
      this._onGetStatus = window.electronApi.onGetStatus(
        this.handleOnGetStatus
      );
    }
  }

  closeScreenShare() {
    if (isElectron()) {
      window.electronApi.closeScreenShare();
    }
  }

  handleOnGetStatus(event, args) {
    logger.debug("onGetStatus işeniyor...");
    const me = store.getState().me;
    const settings = store.getState().settings;
    const room = store.getState().room;
    const options = {
      muted: roomClient._muted,
      webinar: room.webinar,
      hasInterpreterSupporting: room.hasInterpreterSupporting,
      hasWebinarPresenterPermission: me.roles.some((role) =>
        room.permissionsFromRoles.MODERATE_WEBINAR.includes(role)
      ),
      audioInProgress: me.audioInProgress,
      canSendMic: me.canSendMic,
      displayName: settings.displayName,
      id: me.id,
      canSendWebcam: me.canSendWebcam,
      canShareScreen: me.canShareScreen,
      canShareFiles: me.canShareFiles,
      raiseHand: me.raiseHand,
      raiseHandInProgress: me.raiseHandInProgress,
      roles: me.roles,
      screenShareInProgress: me.screenShareInProgress,
      webcamInProgress:
        roomClient._webcamProducer && roomClient._webcamProducer.track !== null,
      aspectRatio: settings.webcamAspectRatio,
      micState: settings.micState,
      roomId: room.name,
    };
    logger.info("Query Response", options);
    window.electronApi.sendQueryResponse(options);
  }

  async handleOnSendWindow(event, response) {
    logger.debug("handleOnSendWindow", response);
    if (response.recording && response.recording === true) {
			if (window.config.ffmpeg.recordToServer) {
				await roomClient.enableScreenRecordingToTheServer({
					id: response.id,
					audio: response.audio,
				});
			} else {
				await roomClient.startRecording({
					id: response.id,
					audio: response.audio,
				});
			}
    } else {
      try {
        logger.debug(roomClient);
        await roomClient.enableScreenSharing({
          id: response.id,
          audio: response.audio,
          isEntireScreen: response.isEntireScreen
        });
      } catch (e) {
        logger.debug(e);
      }
    }
  }

  handleOnQueryStatus() {
    this.QueryResponse();
  }

  QueryResponse() {
    this.handleOnGetStatus();
  }

  // { displayName, peerId }
  changeDisplayName(args) {
    window.electronApi.changeDisplayName(args);
  }

  handleGetRoomParam(e, args) {
    axios.get(window.config.apiServiceUrl + "/roomParam").then((response) => {
      if (response.status === 200) {
        window.electronApi.sendRoomParam({
          key: response.data.roomParam,
          fileId: args.fileId
        });
      }
    });
  }

  onGetRoomParam() {
    logger.info("REGISTER", "onGetRoomParam");
    this._onGetRoomParam = window.electronApi.onGetRoomParam(
      this.handleGetRoomParam
    );
  }

  handleOnToggleScreen() {}

  showSelectSourcewindow() {
    window.electronApi.showSelectSourcewindow();
  }

  async handleListenWebCam() {
    logger.debug("Webcam producer kontrol ediliyor ...");
    if (roomClient._webcamProducer?.track) {
      const deviceId = await roomClient._getWebcamDeviceId();
      let resolution;
      if (
        [...roomClient._consumers.values()].filter(
          (c) => c.kind === "video"
        ) === 0
      )
        resolution = "medium";
      else resolution = roomClient.getOptimizedVideoResolution();
      VIDEO_CONSTRAINS[resolution].aspectRatio =
        store.getState().settings.webcamAspectRatio;

      if (window.electronApi) {
        logger.debug("Webcam bulundu ve bilgiler ekrana geçildi");
        window.electronApi.sendDeviceId({
          enabled: true,
          deviceId,
          resolution,
          VIDEO_CONSTRAINS,
        });
      }
    } else {
      logger.debug("Aktif webcam producer bulunamadı. enable webcam yapalım");
      try {
        roomClient.enableWebcam();
      } catch (e) {
        logger.error(e);
      }
    }
  }

  handleOnGetPeers() {
    const getPeerConsumers = makePeerConsumerSelector();
    const state = store.getState();
    Object.values(state.peers).forEach((peer) => {
      window.electronApi.sendPeer(JSON.stringify({
        ...peer,
        ...getPeerConsumers(state, peer.id),
      }));
    });
  }

  handleOnGetMessagesHistory() {
    if (isElectron()) {
      const messages = store.getState().chat;
      window.electronApi.sendMessagesHistory(messages);
    }
  }

  onGetMessagesHistory() {
    this._onGetMessagesHistory = window.electronApi.onGetMessagesHistory(
      this.handleOnGetMessagesHistory
    );
  }

  handleOnDownloadFile(event, args) {
    logger.info("DOWNLOAD FILE", args);

    let cipher = crypto.createCipheriv(
      window.config.alg,
      args.roomKey,
      window.config.iv
    );

    let encryptedRoomId =
      cipher.update(args.roomId, "utf8", "hex") + cipher.final("hex");

    axios
      .get(window.config.apiFileServiceUrl + args.roomId + "/" + args.fileId, {
        responseType: "blob",
        headers: {
          param: encryptedRoomId,
        },
      })
      .then((result) => {
        FileDownload(result.data, args.fileName);
      });
  }

  onDownloadFile() {
    logger.info("REGISTER", "onDownloadFile");
    this._onDownloadFile = window.electronApi.onDownloadFile(
      this.handleOnDownloadFile
    );
  }

  handleSendParticipantPeers() {
    const getPeerConsumers = makePeerConsumerSelector();
    const state = store.getState();
    Object.values(state.peers).map((peer) => {
      window.electronApi.sendPeer(JSON.stringify({
        ...peer,
        ...getPeerConsumers(state, peer.id),
      }));
    });
  }

  enableWebcam() {
    if (window.electronApi) window.electronApi.enableWebcam();
  }

  sendMessages(messages) {
    if (window.electronApi) window.electronApi.sendMessages(messages);
  }

  sendPeerVolume(param) {
    if (window.electronApi) window.electronApi.sendPeerVolume(param);
  }

  createBottomControl() {
    if (window.electronApi) window.electronApi.createBottomControl();
  }

  sendPeer(peer) {
    const getPeerConsumers = makePeerConsumerSelector();
    const state = store.getState();
    const combine = JSON.stringify({
      ...peer,
      ...getPeerConsumers(state, peer.id)
    });
    window.electronApi.sendPeer(combine);
  }

  sendScore(param) {
    if (window.electronApi) window.electronApi.sendScore(param);
  }

  handleOnSendChatMessage(e, args) {
    logger.debug("OnSendChatMessage", e, args);
    roomClient.sendChatMessage(args);
  }

  onSendChatMessage() {
    this._onSendChatMessage = window.electronApi.onSendChatMessage(
      this.handleOnSendChatMessage
    );
  }

  removePeer(peerId) {
    if (window.electronApi) window.electronApi.removePeer(peerId);
  }

  handleOnModeratorScreenPin(e, args) {
    roomClient.toggleScreenPin(args.peerId, args.flag);
  }

  onModeratorScreenPin() {
    logger.info("REGISTER", "onModeratorScreenPin");
    this._onModeratorScreenPin = window.electronApi.onModeratorScreenPin(
      this.handleOnModeratorScreenPin
    );
  }

  handleOnModeratorEnablePeerMic(e, args) {
    roomClient.sendStartPeerMic(args.peerId);
  }

  onModeratorEnablePeerMic() {
    logger.info("REGISTER", "onModeratorEnablePeerMic");
    this._onModeratorEnablePeerMic =
      window.electronApi.onModeratorEnablePeerMic(
        this.handleOnModeratorEnablePeerMic
      );
  }

  handleOnModeratorStopPeerWebcam(e, args) {
    roomClient.modifyPeerWebcamConsumer(args.peerId, true);
  }

  onModeratorStopPeerWebcam() {
    logger.info("REGISTER", "onModeratorStopPeerWebcam");
    this._onModeratorStopPeerWebcam =
      window.electronApi.onModeratorStopPeerWebcam(
        this.handleOnModeratorStopPeerWebcam
      );
  }

  handleOnModeratorStopPeerMic(e, args) {
    roomClient.sendStopPeerMic(args.peerId);
  }

  onModeratorStopPeerMic() {
    logger.info("REGISTER", "onModeratorStopPeerMic");
    this._onModeratorStopPeerMic = window.electronApi.onModeratorStopPeerMic(
      this.handleOnModeratorStopPeerMic
    );
  }

  handleOnModifyPeerMicConsumer(e, args) {
    roomClient.modifyPeerMicConsumer(args.id, args.flag);
  }

  onModifyPeerMicConsumer() {
    logger.info("REGISTER", "onModifyPeerMicConsumer");
    this._onModifyPeerMicConsumer
      = window.electronApi.onModifyPeerMicConsumer(
      this.handleOnModifyPeerMicConsumer
    );
  }

  handleOnSendAddRole(e, args) {
    roomClient.sendAddRole(args.peerId, args.role)
  }

  onSendAddRole() {
    logger.info("REGISTER", "onSendAddRole");
    this._onSendAddRole
      = window.electronApi.onSendAddRole(
      this.handleOnSendAddRole
    );
  }

  handleOnSendMutedHand(e, args) {
    roomClient.sendMuteHand(args.peerId);
  }

  onSendMutedHand() {
    logger.info("REGISTER", "onSendMutedHand");
    this._onSendMutedHand
      = window.electronApi.onSendMutedHand(
      this.handleOnSendMutedHand
    );
  }

  handleOnModifyPeerScreenConsumer(e, args) {
    roomClient.modifyPeerConsumer(args.peerId, "screen", args.flag)
  }

  onModifyPeerScreenConsumer() {
    logger.info("REGISTER", "onModifyPeerScreenConsumer");
    this._onModifyPeerScreenConsumer
      = window.electronApi.onModifyPeerScreenConsumer(
      this.handleOnModifyPeerScreenConsumer
    );
  }

  handleonChangeModerator (e, args) {
    roomClient.changeModerator(args.peerId);
  }

  onChangeModerator() {
    logger.info("REGISTER", "onChangeModerator");
    this._onChangeModerator
      = window.electronApi.onChangeModerator(
      this.handleonChangeModerator
    );
  }

  handlekickPeer(e, args) {
    roomClient.kickPeer(args.peerId);
  }

  onKickPeer() {
    logger.info("REGISTER", "kickPeer");
    this._onKickPeer
      = window.electronApi.onKickPeer(
      this.handlekickPeer
    );
  }

  handleOnSendRemoveRole (e, args) {
    roomClient.sendRemoveRole(args.peerId, args.role);
  }

  onSendRemoveRole() {
    logger.info("REGISTER", "onSendRemoveRole");
    this._onSendRemoveRole
      = window.electronApi.onSendRemoveRole(
      this.handleOnSendRemoveRole
    );
  }

  handleonSaveFile(e, args) {
    console.log(args);
    const reader = new FileReader();
    reader.onload = () => {
      const buffer = buffer.from()
    };
    reader.readAsArrayBuffer()
    FileServerClient.saveFile(JSON.parse(args.file), args.roomId ,args.uuid);
  }

  onSaveFile() {
    logger.info("REGISTER", "onSaveFile");
    this._onSaveFile
      = window.electronApi.onSaveFile(
      this.handleonSaveFile
    );
  }

  handleOnAcceptControlRequest(e, args) {
    logger.info("SCREEN ARGS", args);
    roomClient.acceptControlRequest(args);
  }

  onAcceptControlRequest () {
    logger.info("REGISTER", "onAcceptControlRequest");
    this._onAcceptControlRequest
    = window.electronApi.onAcceptControlRequest(
        this.handleOnAcceptControlRequest
      );
  }

  handleOnRejectControlRequest (e, args) {
    roomClient.rejectControlRequest(args);
  }

  onRejectControlRequest () {
    logger.info("REGISTER", "onRejectControlRequest");
    this._onRejectControlRequest
    = window.electronApi.onRejectControlRequest(
        this.handleOnRejectControlRequest
      );
  }

  handleOnScreenControlClosed (e, args) {
    roomClient.screenControlClosed();
  }

  onScreenControlClosed () {
    logger.info("REGISTER", "onScreenControlClosed");
    this._onScreenControlClosed
      = window.electronApi.onScreenControlClosed(
      this.handleOnScreenControlClosed
    );
  }

  handleOnSendControlEvent(e, args) {
    roomClient.sendControlEvent(args);
  }

  onSendControlEvent() {
    logger.info("REGISTER", "onSendControlEvent");
    this._onSendControlEvent
      = window.electronApi.onSendControlEvent(
      this.handleOnSendControlEvent
    );
  }

	handleOnPeerPauseConsumer(e, args) {

	}

	onPeerPauseConsumer() {
		logger.info("REGISTER", "onPeerPauseConsumer");
		this._onPeerPauseConsumer =
			window.electronApi.onPeerPauseConsumer(
				this.handleOnPeerPauseConsumer
			);
	}

  subscribeToElectronEvents() {
    if (isElectron()) {
      this.onDownloadFile();
      this.onSendWindowId();
      this.onToggleScreenPin();
      this.onShowWebcam();
      this.onGetPeers();
      this.onGetParticipantPeers();
      this.onDisableWebcamShare();
      this.onDisableScreenShare();
      this.onEnableWebcamShare();
      this.onEnableMicShare();
      this.onDisableMicShare();
      this.onGetStatus();
      this.onGetMessagesHistory();
      this.onSendChatMessage();
      this.onGetRoomParam();
      this.onModeratorScreenPin();
      this.onModeratorEnablePeerMic();
      this.onModeratorStopPeerWebcam();
      this.onModeratorStopPeerMic();
      this.onModifyPeerMicConsumer();
      this.onSendAddRole();
      this.onSendMutedHand();
      this.onModifyPeerScreenConsumer();
      this.onChangeModerator();
      this.onKickPeer();
      this.onSendRemoveRole();
      this.onSaveFile();
      this.onAcceptControlRequest();
      this.onRejectControlRequest();
      this.onScreenControlClosed();
      this.onSendControlEvent();
			this.onPeerPauseConsumer();
    }
  }

  unSubscribeToElectronEvents() {
    if (window.electronApi) {
      this._onDownloadFile();
      this._onSendWindowId();
      this._onGetPeers();
      this._onGetParticipantPeers();
      this._onShowWebcam();
      this._onToggleScreenPin();
      this._onDisableWebcamShare();
      this._onDisableScreenShare();
      this._onEnableWebcamShare();
      this._onEnableMicShare();
      this._onDisableMicShare();
      this._onGetStatus();
      this._onGetMessagesHistory();
      this._onGetRoomParam();
      this._onModeratorScreenPin();
      this._onModeratorEnablePeerMic();
      this._onModeratorStopPeerWebcam();
      this._onModeratorStopPeerMic();
      this._onPeerPauseConsumer();
      this._onModifyPeerMicConsumer();
      this._onSendAddRole();
      this._onSendMutedHand();
      this._onModifyPeerScreenConsumer();
      this._onChangeModerator();
      this._onKickPeer();
      this._onSaveFile();
      this._onAcceptControlRequest();
      this._onRejectControlRequest();
      this._onScreenControlClosed();
      this._onSendControlEvent();
    }
  }
}
